import ButtonDropdown from "@rio-cloud/rio-uikit/ButtonDropdown"
import type { MenuItemProps } from "@rio-cloud/rio-uikit/MenuItem"
import moment from "moment-timezone"
import { FormattedMessage } from "react-intl"
import type { Shipment } from "@/model/transportorder/transportOrder"
import { getInboundEmptiesCsvHeaders, mapInboundEmptiesShipmentsToCsvRows } from "./inboundEmptiesCsvExport"
import { getInboundMaterialCsvHeaders, mapInboundMaterialShipmentsToCsvRows } from "./inboundMaterialCsvExport"
import { downloadInboundCsv } from "./inboundCsvSerializer"
import Icon from "@rio-cloud/rio-uikit/Icon"

type InboundCSVExportButtonDropdownProps = {
    visibleRows: Shipment[]
    dateFrom: Date
    dateTo: Date
}

export const partitionInboundExportRows = (rows: Shipment[]) => ({
    empties: rows.filter(row => row.freight.type === "CARGO_EMPTIES"),
    materials: rows.filter(row =>
        row.freight.type === "CARGO_MATERIAL" ||
        row.freight.type === "BULK_DRY" ||
        row.freight.type === "BULK_LIQUID",
    ),
})

export const InboundCSVExportButtonDropdown = ({
    visibleRows,
    dateFrom,
    dateTo,
}: InboundCSVExportButtonDropdownProps) => {
    const { empties, materials } = partitionInboundExportRows(visibleRows)
    const formattedDateRange = `${moment(dateFrom).format("YYYY-MM-DD_HHmm")}_` +
        moment(dateTo).format("YYYY-MM-DD_HHmm")
    const items: MenuItemProps[] = [
        {
            value: <FormattedMessage id={"transportOrder.csvexport.material.buttonText"} />,
            disabled: materials.length === 0,
            onSelect: () => downloadInboundCsv(
                mapInboundMaterialShipmentsToCsvRows(materials),
                getInboundMaterialCsvHeaders(),
                `exported_inbound_materials_transportorders_${formattedDateRange}.csv`,
            ),
        },
        {
            value: <FormattedMessage id={"transportOrder.csvexport.empties.buttonText"} />,
            disabled: empties.length === 0,
            onSelect: () => downloadInboundCsv(
                mapInboundEmptiesShipmentsToCsvRows(empties),
                getInboundEmptiesCsvHeaders(),
                `exported_inbound_empties_transportorders_${formattedDateRange}.csv`,
            ),
        },
    ]

    return (
        <ButtonDropdown
            title={<>
                <Icon iconName={"icon-document-out"} />
                <FormattedMessage id="transportOrder.common.csvExport" />
            </>}
            items={items}
            disabled={visibleRows.length === 0}
        />
    )
}
